import { render, staticRenderFns } from "./createWarehouse.vue?vue&type=template&id=db8098b0&scoped=true"
import script from "./createWarehouse.vue?vue&type=script&lang=js"
export * from "./createWarehouse.vue?vue&type=script&lang=js"
import style0 from "./createWarehouse.vue?vue&type=style&index=0&id=db8098b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8098b0",
  null
  
)

export default component.exports